// Мультиязычность RU (по умолчанию) + EN — docs/DECISIONS.md.
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ru: {
    translation: {
      loading: "Загрузка…",
      days_short: "дн.",
      // Навигация — 4 вкладки на 8 экранов ТЗ раздел 3.3, устройства/платежи/отмена/промокод
      // объединены с соседними экранами (см. App.tsx, MySubscriptionScreen.tsx, MoreScreen.tsx)
      nav_plans: "Тарифы",
      nav_subscription: "Подписка",
      nav_change_plan: "Апгрейд",
      nav_more: "Ещё",
      more_title: "Ещё",
      // Экран 1 — витрина тарифов
      plans_title: "Витрина тарифов",
      plans_error: "Не удалось загрузить тарифы — попробуйте позже.",
      plans_empty: "Тарифы временно недоступны.",
      plans_device_range: "от 1 до {{max}} устройств",
      buy: "Купить",
      // Экран 3 — моя подписка
      subscription_title: "Моя подписка",
      subscription_error: "Не удалось загрузить подписку — попробуйте позже.",
      subscription_none: "У вас нет активной подписки. Оформите на экране «Тарифы».",
      subscription_plan: "Тариф",
      subscription_status: "Статус",
      subscription_expires_at: "Действует до",
      status_active: "активна",
      status_expiring: "скоро истекает",
      status_expired: "истекла",
      status_cancelled: "отменена",
      devices_empty: "Устройства не привязаны.",
      // Экран 2 — оформление подписки
      checkout_title: "Оформление подписки",
      checkout_plan_not_found: "Тариф не найден или недоступен.",
      checkout_quantity_label: "Количество устройств",
      checkout_amount_due: "К оплате",
      checkout_payment_method: "Оплата через Telegram Payments.",
      checkout_pay: "Оплатить",
      checkout_payment_failed: "Оплата не прошла — попробуйте ещё раз.",
      // Экран 4 — устройства
      devices_title: "Устройства",
      devices_primary: "основное",
      devices_show_links: "Ссылки на установку",
      devices_detach: "Отвязать",
      devices_links_pending: "Ссылки появятся чуть позже — попробуйте обновить.",
      devices_name_placeholder: "Название устройства",
      devices_attach: "Привязать новое",
      devices_limit_reached: "Достигнут лимит устройств тарифа — оформите апгрейд на экране «Смена тарифа».",
      devices_new_links_title: "Устройство привязано, скачайте антивирус:",
      // Экран 6 — история платежей
      payments_title: "История платежей",
      payments_error: "Не удалось загрузить историю платежей — попробуйте позже.",
      payments_empty: "Платежей пока нет.",
      payment_status_pending: "в обработке",
      payment_status_succeeded: "успешно",
      payment_status_failed: "не прошёл",
      payment_status_refunded: "возвращён",
      payment_type_purchase: "покупка",
      payment_type_renewal: "продление",
      payment_type_upgrade: "смена тарифа",
      payment_type_refund: "возврат",
      // Экран 8 — промокоды
      promo_title: "Промокод",
      promo_code_placeholder: "Введите промокод",
      promo_submit: "Активировать",
      promo_success: "Промокод активирован! Скачайте антивирус:",
      // Экран 7 — отмена подписки (только автопродление, см. MoreScreen.tsx)
      cancel_title: "Отмена подписки",
      cancel_auto_renew_status: "Автопродление",
      cancel_auto_renew_on: "включено",
      cancel_auto_renew_off: "выключено",
      cancel_note_still_active: "Подписка останется активной до конца оплаченного периода.",
      cancel_action_cancel: "Отключить автопродление",
      cancel_action_resume: "Включить автопродление",
      // Экран 5 — смена тарифа (только апгрейд, см. ChangePlanScreen.tsx)
      change_plan_title: "Смена тарифа",
      change_plan_current: "Текущий тариф",
      change_plan_note: "Доступен только переход на более дорогой тариф — доплата пересчитывается пропорционально оставшемуся сроку.",
      change_plan_bundle_unavailable: "Смена тарифа недоступна для «Расширенного» — это отдельная пара подписок.",
      change_plan_no_candidates: "Нет доступных тарифов для перехода.",
      change_plan_switch: "Перейти",
      change_plan_payment_failed: "Оплата не прошла — попробуйте ещё раз.",
    },
  },
  en: {
    translation: {
      loading: "Loading…",
      days_short: "days",
      nav_plans: "Plans",
      nav_subscription: "Subscription",
      nav_change_plan: "Upgrade",
      nav_more: "More",
      more_title: "More",
      plans_title: "Plans",
      plans_error: "Failed to load plans — please try again later.",
      plans_empty: "No plans available right now.",
      plans_device_range: "1 to {{max}} devices",
      buy: "Buy",
      subscription_title: "My subscription",
      subscription_error: "Failed to load your subscription — please try again later.",
      subscription_none: "You don't have an active subscription. Get one on the Plans screen.",
      subscription_plan: "Plan",
      subscription_status: "Status",
      subscription_expires_at: "Valid until",
      status_active: "active",
      status_expiring: "expiring soon",
      status_expired: "expired",
      status_cancelled: "cancelled",
      devices_empty: "No devices attached.",
      checkout_title: "Checkout",
      checkout_plan_not_found: "Plan not found or unavailable.",
      checkout_quantity_label: "Number of devices",
      checkout_amount_due: "Amount due",
      checkout_payment_method: "Payment via Telegram Payments.",
      checkout_pay: "Pay",
      checkout_payment_failed: "Payment failed — please try again.",
      devices_title: "Devices",
      devices_primary: "primary",
      devices_show_links: "Install links",
      devices_detach: "Detach",
      devices_links_pending: "Links will appear shortly — try refreshing.",
      devices_name_placeholder: "Device name",
      devices_attach: "Attach new",
      devices_limit_reached: "Plan device limit reached — upgrade on the Change plan screen.",
      devices_new_links_title: "Device attached, download the antivirus:",
      payments_title: "Payment history",
      payments_error: "Failed to load payment history — please try again later.",
      payments_empty: "No payments yet.",
      payment_status_pending: "pending",
      payment_status_succeeded: "succeeded",
      payment_status_failed: "failed",
      payment_status_refunded: "refunded",
      payment_type_purchase: "purchase",
      payment_type_renewal: "renewal",
      payment_type_upgrade: "plan change",
      payment_type_refund: "refund",
      promo_title: "Promo code",
      promo_code_placeholder: "Enter promo code",
      promo_submit: "Activate",
      promo_success: "Promo code activated! Download the antivirus:",
      cancel_title: "Cancel subscription",
      cancel_auto_renew_status: "Auto-renew",
      cancel_auto_renew_on: "on",
      cancel_auto_renew_off: "off",
      cancel_note_still_active: "Your subscription stays active until the end of the paid period.",
      cancel_action_cancel: "Turn off auto-renew",
      cancel_action_resume: "Turn on auto-renew",
      change_plan_title: "Change plan",
      change_plan_current: "Current plan",
      change_plan_note: "Only switching to a more expensive plan is supported — the extra charge is prorated for the remaining period.",
      change_plan_bundle_unavailable: "Plan change isn't available for \"Extended\" — it's a separate pair of subscriptions.",
      change_plan_no_candidates: "No plans available to switch to.",
      change_plan_switch: "Switch",
      change_plan_payment_failed: "Payment failed — please try again.",
    },
  },
};

void i18n.use(initReactI18next).init({
  resources,
  lng: "ru",
  fallbackLng: "ru",
  interpolation: { escapeValue: false },
});

export default i18n;
